import {useEffect, useMemo, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {Column} from 'react-table'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useMultiUser} from '../../../../hooks/limpieza/useMultiUser'
import {MULTI_USER_CREW_SERVICES} from '../../../../services/multi-user-crew.service'
import {ModalAddCleaningActivity} from '../modal/add-cleaning-activity'
import {ModalCleaningActivities} from '../modal/cleaning-activity'
import {ModalScanCleaningActivity} from '../modal/scan-cleaning-activity'

const TableCleaningActivities = ({
  onOpenCleaningActivities,
}: {
  onOpenCleaningActivities: () => void
}) => {
  const {data, setData, setPagination, loading, setLoading, pagination, selectedOn} = useKTable()
  const [showModalActivity, setShowModalActivity] = useState(false)
  const [showModalScan, setShowModalScan] = useState(false)
  const {
    campaments,
    schedules: programmingServices,
    clearSchedules: clearProgrammingServices,
    getSchedulesService: getProgrammingServices,
  } = useMultiUser()

  const {setValue, setError, watch} = useFormContext()

  const getListScan = async () => {
    try {
      setLoading(true)
      const {data: response} = await MULTI_USER_CREW_SERVICES.getListScan({
        ServiceSchedulingId: watch('ProgramacionServicioId'),
        pageNumber: pagination.currentPage,
        size: 10,
      })
      if (!response.error) {
        setData(response.data)
        if (response.data.length > 0) {
          setValue('EscaneoId', response.EscaneoId || '')
          setValue('ActividadesCompletadas', response.ActividadesCompletadas || false)
        }
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getListScan()
  }, [pagination.currentPage])

  const handleScan = () => {
    setShowModalScan(true)
  }

  const handleAddActivity = () => {
    setShowModalActivity(true)
  }

  const handleShowCleaningActivities = () => {
    onOpenCleaningActivities()
  }

  const handleCampamentChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    setValue('ProgramacionServicioId', '')
    clearProgrammingServices()
    getProgrammingServices({CampamentoId: value, pageNumber: 1, size: 100})
  }

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nr Celular' />,
        accessor: 'Celular',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Actividad' />,
        accessor: 'Actividad',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado Actividad' />,
        accessor: 'Tipo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Hora de Registro' />,
        accessor: 'Hora',
      },
    ],
    [selectedOn],
  )

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  useEffect(() => {
    if (programmingServices.length === 1) {
      setValue('ProgramacionServicioId', programmingServices[0].value)
      setError('ProgramacionServicioId', {})
    }
  }, [programmingServices])

  return (
    <>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-md-6'>
          <SelectWrapper
            labelText='Campamento'
            name='CampamentoId'
            data={campaments}
            required
            onChangeValue={handleCampamentChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-6'>
          <SelectWrapper
            labelText='Programación de Servicio'
            name='ProgramacionServicioId'
            data={programmingServices}
          />
        </div>
      </div>
      <div className='d-flex justify-content-between py-3'>
        <button type='button' className='btn btn-sm btn-success' onClick={handleScan}>
          Escanear
        </button>
        <button
          type='button'
          className='btn btn-sm btn-primary'
          onClick={handleShowCleaningActivities}
          // disabled={searching}
        >
          Servicios de Limpieza
        </button>
        <button
          type='button'
          className='btn btn-sm btn-success'
          // disabled={selectedOn.length < 1}
          onClick={handleAddActivity}
        >
          Ingresar Actividad
        </button>
      </div>
      <div className='fv-row position-relative mt-5'>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={data} columns={columns} paddingTable={false} showButtons={false} />
      </div>
      {showModalActivity && (
        <ModalAddCleaningActivity
          show={showModalActivity}
          setShow={setShowModalActivity}
          onScanSuccess={async () => {
            await getListScan()
          }}
        />
      )}
      {showModalScan && (
        <ModalScanCleaningActivity
          show={showModalScan}
          setShow={setShowModalScan}
          onScanSuccess={async () => {
            await getListScan()
          }}
        />
      )}
    </>
  )
}

export const CleaningActivitiesTable = () => {
  const [showCleaningActivities, setShowCleaningActivities] = useState(false)

  const handleOpenCleaningActivities = () => {
    setShowCleaningActivities(true)
  }
  return (
    <>
      <KTableProvider>
        <TableCleaningActivities onOpenCleaningActivities={handleOpenCleaningActivities} />
      </KTableProvider>
      <KTableProvider>
        {showCleaningActivities && (
          <ModalCleaningActivities
            show={showCleaningActivities}
            setShow={setShowCleaningActivities}
          />
        )}
      </KTableProvider>
    </>
  )
}
